module.exports = __webpack_public_path__ + "media/images/lb/360-267cbbafe7f380ce7e4d4bebc152e0a3.svg";